import React from "react";
import Modal from "react-modal";
import {usePDF} from "react-to-pdf";
import { Download } from 'react-bootstrap-icons';

function PreviewFile(props){

    // CONFIG

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() { setIsOpen(true); }
    function closeModal() { setIsOpen(false); }

    // Export to PDF

    const { toPDF, targetRef } = usePDF({
        filename: `${props.name}.pdf`,
        overrides: {
            pdf: {compress: true,},
            canvas: {useCORS: true,},
        },
    });

    return <div id={'preview-file'}>
        <button onClick={openModal} className={'btn btn-outline-dark  m-1'}>PDF</button>
        <Modal
            isOpen={modalIsOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            class={'col-md-7'}
        >
            <div className="container">
                <div className="d-flex justify-content-between">
                    <div>
                        <h2>Попередній перегляд</h2>
                    </div>
                    <div>
                        <button type={'button'} onClick={() => toPDF()}
                                className={'btn btn-dark m-1 text-uppercase'}>
                            <Download /> завантажить</button>
                        <button onClick={closeModal}
                                className={'btn btn-outline-dark m-1 text-uppercase'}>закрить</button>
                    </div>
                </div>
                <br/>
                <div style={{height: "80vh"}}>
                    <div ref={targetRef}
                         style={{
                             fontSize: '14px',
                             padding: '35mm', // Apply padding to the content area
                             width: '210mm', // A4 width for context
                             minHeight: '297mm' // A4 height for context
                         }}
                         id={'preview'}
                         className="col-md-12 p-3"
                    >

                        <div className="text-center">
                            <h2>
                                Інформаційна довідка
                            </h2>
                            <p>
                                на об'єкт <b className="text-uppercase">{props.name}</b>
                            </p>
                        </div>

                        <div dangerouslySetInnerHTML={{ __html: props.content }} />

                    </div>
                </div>
            </div>
        </Modal>
    </div>;
}

export default PreviewFile;